import SwivuSettingsTagValueTabBase from "./SwivuSettingsTagValueTabBase.jsx";
import { TAGS_KEYS } from "../../../other/constants/TagsKeys.jsx";
import { STORE_KEYS } from "../../../other/constants/StoreKeys.jsx";
import {GRANTS} from "../../../other/constants/PrivilegeTypes.jsx";
import {SETTING_TAB_WIDGET_KEYS} from "../../../other/constants/OtherKeys.jsx";

const GRID_KEYS = {
  tagsGrid: "resourceTagsGrid"
};

export default class SwivuSettingsResourceTagsTab extends SwivuSettingsTagValueTabBase {
  static get $name() {
    return "SwivuSettingsResourceTagsTab";
  }

  static get type() {
    return "swivusettingsresourcetagstab";
  }

  get swivuDeepLinkSlug() {
    return SETTING_TAB_WIDGET_KEYS.resourceTagsTab;
  }

  getStoreName() {
    return STORE_KEYS.resourceTagValuesStore;
  }

  getTagKeysWithWidgetRef() {
    return {
      [TAGS_KEYS.tag]: GRID_KEYS.tagsGrid
    };
  }

  swivuCheckGrants(user) {
    if (!user.can(GRANTS.grant_one)) {
      const grid = this.widgetMap[GRID_KEYS.tagsGrid];
      grid.disabled = true;
      grid.readOnly = true; // readonly will prevent row reorder
      grid.bbar.items.forEach(
        (item) => (item.disabled = true)
      );
    }
  }

  static get configurable() {
    return {
      title: "Resources",
      scrollable: true,
      ...SwivuSettingsTagValueTabBase.getDefaultLayoutSettings(),
      items: {
        [GRID_KEYS.tagsGrid]: SwivuSettingsTagValueTabBase.getGridWidget({
          headerText: "Resource Tags",
          defaultValue: "Enter Tag"
        })
      }
    };
  }
}

SwivuSettingsResourceTagsTab.initClass();
